import React from 'react';
import { useTranslation } from 'react-i18next';
import { cloneDeep } from 'lodash';
import CustomTooltip from '../../../../../Components/Tooltip/CustomTooltip';
import SampleImg from '../SampleImg';

function CardDrag({
  item,
  index,
  handleNameChange,
  setDeleteImageId,
  setShowConfirmation,
  annotatedImage,
  isProductArchived,
  SampleDeleteAccess,
  SampleAddEditAccess,
}) {
  const updatedItem = cloneDeep(item);
  const { t } = useTranslation('common');
  return (
    <div className="annotation-item" key={index}>
      <div className="input-action-row">
        <div className="input-group ">
          <input
            type="text"
            className="form-control text-bordered "
            placeholder="Title"
            value={updatedItem?.name ? updatedItem?.name : ''}
            name={`annotationsImages[${index}].name`}
            onChange={(e) => handleNameChange(e, index)}
            disabled={isProductArchived || !SampleAddEditAccess}
          />
        </div>
        {!isProductArchived && (
          <>
            {SampleAddEditAccess && (
              <CustomTooltip tooltipText={t('COMMON.EDIT')}>
                <button
                  aria-label="Edit"
                  type="button"
                  className="btn btn-outline xl ml-16 mr-0"
                  onClick={() => annotatedImage({ img: item.image, id: item._id })}
                >
                  <span className="icon-Edit-1 f-24" />
                </button>
              </CustomTooltip>
            )}
            {SampleDeleteAccess ? (
              <CustomTooltip tooltipText={t('COMMON.DELETE')}>
                <button
                  aria-label="Delete"
                  type="button"
                  className="btn btn-outline xl ml-16 mr-0"
                  onClick={() => {
                    setDeleteImageId({
                      designImageId: item._id,
                      image: item?.image,
                      isSupplierAnnotation: true,
                      title: item?.name || '',
                    });
                    setShowConfirmation(true);
                  }}
                >
                  <span className="icon icon-Delete f-24" />
                </button>
              </CustomTooltip>
            ) : (
              ''
            )}
          </>
        )}
      </div>
      <div className="annotation-img-container">
        <SampleImg src={item?.annotedImage || item?.image} />
        <input type="text" name={`annotationsImages[${index}].image`} className="d-none" />
      </div>
    </div>
  );
}
export default CardDrag;
